import { ActionTree } from 'vuex'
import { SnackState } from './snack.types'
import { MutationTypes } from './snack.mutations'

export const actions: ActionTree<SnackState, unknown> = {
  setSnack({ commit }, { val, text, variant, timeout }) {
    commit(MutationTypes.SET_SNACK, { val, text, variant, timeout })
  }
}
